import * as React from 'react';
import * as _ from 'lodash';
import { connect, Dispatch } from 'react-redux';
import { findDOMNode } from 'react-dom';

import ListMonthView, { ListViewRowExternalProps } from '../views/list-month';
import { ICalendarReduxState } from "../classes/index";
import { RawActions } from "@adage/ace-calendar";
import { updateClientRect } from "../redux/actions/index";
import { interpolateMonth } from '../helpers/index';

interface StateToProps {
    emptyMonthsMessage: string;
}

interface DispatchToProps {
    updateClientRect: (month: string, element: HTMLElement) => any;
}

type MonthProps = ListViewRowExternalProps & StateToProps & DispatchToProps;

class ListMonth extends React.Component<MonthProps, null> {
    componentDidMount() {
        this.updateRedux();
        window.addEventListener("resize", this.boundOnResize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.boundOnResize);
    }

    private boundOnResize = _.throttle(this.updateRedux.bind(this), 500)

    private updateRedux() {
        const thisComponent: HTMLElement = findDOMNode(this);
        this.props.updateClientRect(this.props.monthMoment.format("MMMM-YYYY"), thisComponent);
    }

    render() {
        return (
            <ListMonthView eventMonth={this.props.eventMonth} monthMoment={this.props.monthMoment} innerHtml={interpolateMonth(this.props.emptyMonthsMessage, this.props.monthMoment)} />
        );
    }
}

function mapStateToProps(state: ICalendarReduxState) {
    return {
        emptyMonthsMessage: state.calendarTextModel.text.emptyMonthMessage
    }
}

function mapDispatchToProps(dispatch: Dispatch<ICalendarReduxState>): DispatchToProps {
    return {
        updateClientRect: (month: string, element: HTMLElement) => dispatch(updateClientRect(month, element))
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(ListMonth);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/components/list-month.tsx